<template>
  <div
    class="in-banner"
    :style="{ backgroundImage: `url(${this.$route.meta.img})` }"
    >
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.in-banner {
  width: 100%;
  height: 360px;
  background: center no-repeat;
  background-size: cover;
  @media only screen and (max-width: 1200px) {
    height: 100px;
  }
}
</style>
